import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { IMAGES } from "../../mock";

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-charcoal">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.heroPortrait}
          alt="Aesthetic beauty"
          className="w-full h-full object-cover object-center hero-kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/90 via-charcoal/55 to-charcoal/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-transparent to-charcoal/40" />
      </div>

      <div className="relative z-10 max-w-[1300px] mx-auto px-6 w-full pt-24">
        <div className="max-w-2xl">
          <div className="reveal is-visible flex items-center gap-3 mb-6">
            <span className="gold-rule" />
            <span className="eyebrow text-gold">Edmonton · Brewery District</span>
          </div>
          <h1 className="font-display text-cream text-5xl sm:text-6xl lg:text-7xl leading-[1.05] font-light">
            The Home of
            <br />
            <span className="italic text-gold">Beauty</span> &amp; Aesthetics
          </h1>
          <p className="font-sans text-cream/75 text-lg leading-relaxed mt-8 max-w-xl">
            A high-end medical spa offering physician-led cosmetic treatments — crafted to reveal your most natural, radiant and confident self.
          </p>
          <div className="flex flex-wrap items-center gap-4 mt-10">
            <Link to="/contact" className="btn-gold">Book Free Consultation</Link>
            <Link to="/services" className="btn-outline-gold">Explore Treatments</Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-cream/50 flex flex-col items-center gap-2 animate-bounce">
        <span className="eyebrow text-[0.6rem]">Discover</span>
        <ChevronDown size={20} />
      </div>
    </section>
  );
}
